export enum CompareTypeEnum {
    Bundles = 0,

    // https://dev.waves.com/hardware/soundgrid-servers
    SoundGridServers = 1,
}